import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Switch, useParams } from 'react-router-dom';
import { useQuery } from '@redux-requests/react';
import routesByName from 'constants/routes';
import AppSettings from '../AppSettings/AppSettings';
import { getApp, IAppCountry } from '../store/actions';
import NavBrand from './components/NavBrand/NavBrand';
import Navigation from './components/Navigation/Navigation';
import { AppsConstants } from '../store/constants';
import { TimifyLoader } from 'components';
import AppWebhooks from '../AppWebhooks/AppWebhooks';
import { AuthoriseAccountsModal, ImagePreviewModal } from 'components/modals';
import WebhookLogs from '../WebhookLogs/WebhookLogs';
import AppDistribution from '../AppDistribution/AppDistribution';
import styles from './AppDetail.module.scss';
import { Page404 } from 'modules';
import AppPricing from '../AppPricing/AppPricing';

const AppDetail: FC = (props) => {
  const { id } = useParams<{ id: string }>();
  const { loading, data, error } = useQuery({ type: AppsConstants.APP, requestKey: id });
  const dispatch = useDispatch();
  const { isFetched, version, isPublic, plan, allowedCountries } = data || {};

  useEffect(() => {
    if (!isFetched) dispatch(getApp(id));
  }, [dispatch, id, isFetched]);

  if (loading) {
    return (
      <div className={styles.spinner}>
        <TimifyLoader />
      </div>
    );
  }

  const isPaid = allowedCountries?.reduce((isCountryPaid: boolean, country: IAppCountry) => {
    if (isCountryPaid) return true;
    return country.hasPayment;
  }, false);

  if (error || !data) return <Page404 />;

  return (
    <div className='container'>
      <div className={styles.root}>
        <Navigation version={version} isPublic={isPublic} plan={plan} isPaid={isPaid} />

        <div className={styles.container}>
          <NavBrand id={id} />
          <div className={styles.main}>
            <Switch>
              <Route path={routesByName.apps.detail.index()} exact>
                <AppSettings id={id} />
              </Route>
              <Route path={routesByName.apps.detail.distribution()} exact>
                <AppDistribution id={id} />
              </Route>
              <Route path={routesByName.apps.detail.pricing()} exact>
                <AppPricing id={id} />
              </Route>
              <Route path={routesByName.apps.detail.webhooks()} exact>
                <AppWebhooks id={id} />
              </Route>
              <Route path={routesByName.apps.detail.webhookLogs()} exact>
                <WebhookLogs id={id} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
      <AuthoriseAccountsModal />
      <ImagePreviewModal />
    </div>
  );
};

export default AppDetail;
